document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.diip-faq');
  if (!section) return;

  /* ---------- Accordion เปิด/ปิดคำตอบ ---------- */
  section.querySelectorAll('.diip-faq-item').forEach(function (item) {
    var button = item.querySelector('.diip-faq-item__question');
    if (!button) return;

    button.addEventListener('click', function () {
      item.classList.toggle('is-open');
    });
  });

  /* ---------- Pill Filter หมวดหมู่ (หน้าเดียว ไม่เปลี่ยน URL) ---------- */
  var pills = section.querySelectorAll('.diip-faq__pill');
  var items = section.querySelectorAll('[data-faq-item]');

  function showCategory(category) {
    items.forEach(function (item) {
      var matches = item.getAttribute('data-category') === category;
      item.classList.toggle('is-hidden', !matches);
      // ปิดคำตอบที่เปิดค้างไว้เมื่อสลับหมวด กันสับสน
      if (!matches) item.classList.remove('is-open');
    });
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      showCategory(pill.getAttribute('data-faq-category'));
    });
  });

  // แสดงหมวดแรกเป็นค่าเริ่มต้น (ไม่มี "ทั้งหมด" ตามที่ขอ)
  if (pills.length > 0) {
    showCategory(pills[0].getAttribute('data-faq-category'));
  }
});
